<template>
  <div class="Investment-box depositbox Liabilities-card-section" v-if="showLandingPageContent==true">
      <div class="card-box">
        <h4>Select your option</h4>
        <v-row>
          <template>
            <v-card
              v-for="categoryList in category"
              :key="categoryList.id"
              class="boxs"
              outlined
              @click="showContent(categoryList.id)">
              <v-list-item three-line>
                <v-list-item-content>
                  <div class="overline">
                    <v-img max-height="39" max-width="39" :src="iconUrl + categoryList.web_icon"></v-img>
                  </div>
                  <v-list-item-title><h4>{{categoryList.subcategory_name}}</h4></v-list-item-title>
                  <p>{{categoryList.desc}}</p>
                </v-list-item-content>
                <v-btn @click="subcategory(categoryList.childsubcategory,categoryList.subcategory_name,categoryList.id,categoryList.jump_to_router)" text> 
                </v-btn>
              </v-list-item>
            </v-card>
          </template>
        </v-row>
      </div>
  </div>
</template>
<script>
import { POST_API, GET_API , UPDATE_USER_DETAILS} from "../../store/actions.type";
import ApiService from '../../api/api.service';
import JwtService from ".././common/jwt.service";
import { Auth } from "aws-amplify";
import axios from "axios";
import qs from 'qs'

export default {
  data: () => ({
    category:[{'id':1, 'subcategory_name':'FinTalk', 'web_icon':'FinTalk_active.png', 'desc':"Confused with financial jargons. Not any more. Demystify finance with Nimeya's FinTalk - we make finance easy for all."}, {'id':2, 'subcategory_name':'FinStat', 'web_icon':'FinStat_active.png', 'desc':"Highest FD rates, best MFs. Post Office scheme returns. How to choose? Decisions to choose the right investment tool work best when you have the right & latest information. With Nimeya’s FinStat you can get all at your fingertips."}],
    iconUrl:process.env.VUE_APP_ROOT_ICONS_URL,
    sud_life_id : '',
    showLandingPageContent:false,  
    forWardIconUrl: process.env.VUE_APP_ROOT_ICONS_URL+'forword_arrow.png'  
  }),

  created(){
    if(this.$route.query.q ==undefined || this.$route.query.q =='' || this.$route.query.s ==undefined || this.$route.query.s ==''){
      this.showLandingPageContent = false;
      alert('Something went wrong!');
      return false;
    }
    else{
      localStorage.setItem('q', this.$route.query.q);
      localStorage.setItem('s', this.$route.query.s);
      localStorage.setItem('sudLifeId', atob(decodeURIComponent(this.$route.query.q)))
      // let youMatterBaseUrl   = "https://coreuat.youmatterhealth.com/Proxy/Registration/ValidateToken?AuthenticationToken=";
      let youMatterBaseUrl   = "https://prodapi.youmatterhealth.com/Proxy/Registration/ValidateToken?AuthenticationToken=";
      let formdata = new FormData();
      axios.post(youMatterBaseUrl+atob(decodeURIComponent(this.$route.query.s)), formdata).then((response) => {
        let stringfyResponse = JSON.parse(response.data);
        if(stringfyResponse.IsSession !=false){
          setTimeout(()=>{
            this.showLandingPageContent = true;
          }, 1000); 
        }
        else{
          console.log("Access Token Error!")
          this.showLandingPageContent = false;
          alert("Invalid Access Token!");
        }
      }); 
    }
  }, 
  
  methods: {
    showContent(id){
      localStorage.setItem('finCat', id);
      if(id==1){
        this.$router.push({ name: 'SudLifeFinTalkCategory' }).catch(()=>{});
      }
      else{
        this.$router.push({ name: 'SudLifeFinStatCategory' }).catch(()=>{});
      }
    }
  }
}
</script>